import React, { useContext } from "react";
import { makeStyles } from "@material-ui/core";
import { Button, Modal } from "@mantine/core";
import { useSelector } from "react-redux";
import { useDisclosure } from "@mantine/hooks";
import { AppContext, TOAST } from "../../../../context";

import Card from "./Card";
import { useState } from "react";
import { handleCancel } from "../../util";

const useStyles = makeStyles((theme) => ({
  cardContainer: {
    width: "50%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: "25px",
    "@media(max-width: 750px)": {
      width: "100%",
      order: 0,
    },
  },
  infoContainer: {
    width: "75%",
    display: "flex",
    flexDirection: "column",
    textAlign: "center",
    gap: "10px",
    paddingBottom: "30px",
    alignItems: "center",
  },
  modalInfoContainer: {
    marginBottom: "20px",
  },
  modalButtonContainer: {
    display: "flex",
    justifyContent: "flex-end",
    gap: "10px",
  },
  buttonContainer: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    alignItems: "center",
    gap: "10px",
  },
  button: {
    maxWidth: "250px",
    width: "50%",
  },
}));

const CardSection = ({
  data,
  updatePaymentCardUrl,
  status,
  subscriptionId,
  canUpdatePaymentCard,
}) => {
  const classes = useStyles();

  // Get posId from updatePaymentCardUrl
  const url = new URL(updatePaymentCardUrl);
  const params = new URLSearchParams(url.search);
  const baseUrl = url.origin;
  const posId = params.get("pos");

  const { config } = useSelector((state) => ({
    config: state.infrastructure.config,
  }));

  const { dispatch } = useContext(AppContext);
  const [loading, setLoading] = useState(false);
  const [modalOpened, { open: openModal, close: closeModal }] =
    useDisclosure(false);

  const { subscriptionTermType } = data.subscriptionDetails;

  const accessToken = useSelector((state) => state.oidc.user.access_token);

  const canCancel = status === "Aktiv" && subscriptionTermType === "Ongoing";
  const cancelUri = `${config.apiUrl}/subscription/cancel/${subscriptionId}`;
  const activateSubscriptionUrl = `${baseUrl}/checkout/subscription?subscriptionId=${subscriptionId}&cul=sv-SE&cur=SEK&pos=${posId}
  `;

  const cancelSubscription = () => {
    fetch(cancelUri, {
      method: "POST",
      headers: {
        authorization: "Bearer " + accessToken,
      },
    }).then((response) => {
      if (response.ok) {
        handleCancel(TOAST, setLoading, dispatch, true);
      } else {
        response
          .text()
          .then((errorMsg) =>
            handleCancel(TOAST, setLoading, dispatch, false, errorMsg)
          );
      }
    });
  };

  return (
    <section className={classes.cardContainer}>
      {status === "Registrerad" ? (
        <div className={classes.buttonContainer}>
          <div className={classes.infoContainer}>
            <p>Detta abonnemang är inte aktivt</p>
            <p>
              Tryck på nedan länk och genomför första dragningen för att
              aktivera abonnemanget
            </p>
          </div>
          <Button
            className={classes.button}
            component={"a"}
            href={activateSubscriptionUrl}
          >
            Aktivera abonnemang
          </Button>
        </div>
      ) : (
        <>
          <Card cardData={data.subscriptionDetails} />
          <div className={classes.buttonContainer}>
            {canUpdatePaymentCard && (
              <Button
                className={classes.button}
                component={"a"}
                href={updatePaymentCardUrl}
              >
                Byt betalkort
              </Button>
            )}
            {canCancel && (
              <>
                <Modal
                  opened={modalOpened}
                  onClose={closeModal}
                  centered
                  title="Bekräfta"
                >
                  <div className={classes.modalInfoContainer}>
                    <p>Är du säker på att du vill avbryta ditt abonnemang?</p>
                    <p>Detta steg går inte att ångra.</p>
                  </div>
                  <div className={classes.modalButtonContainer}>
                    <Button
                      variant="light"
                      onClick={closeModal}
                      disabled={loading}
                    >
                      Stäng
                    </Button>
                    <Button onClick={cancelSubscription} loading={loading}>
                      Bekräfta
                    </Button>
                  </div>
                </Modal>
                <Button
                  className={classes.button}
                  styles={(theme) => ({
                    root: {
                      backgroundColor: theme.colors.red,
                      "&:hover": theme.fn.hover({
                        backgroundColor: theme.fn.darken("#b92727", 0.05),
                      }),
                    },
                  })}
                  onClick={openModal}
                >
                  Avbryt abonnemang
                </Button>
              </>
            )}
          </div>
        </>
      )}
    </section>
  );
};

export default CardSection;
